import React from 'react';
import { Button } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import LensIcon from '@material-ui/icons/Lens';
import LensOutlinedIcon from '@material-ui/icons/LensOutlined';
import RemoveIcon from '@material-ui/icons/Remove';
import StopIcon from '@material-ui/icons/Stop';
import { StrikeColors } from '../../../lib/constants';
import { type IBlock, type IStrike, StrikeShape } from '../../../store/senderBuild/types';
import BlockToolbar from '../../common/BlockToolbar';

interface IProps {
  block: IBlock;
  handleColorClick: (color: string) => void;
  handleShapeClick: (shape: StrikeShape) => void;
  blockOptions?: any;
}

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const StrikeBlockToolbar = (props: IProps) => {
  const { block, handleColorClick, handleShapeClick } = props;
  const strikeColor = block.color?.toLowerCase() || StrikeColors.Black;
  const strikeShape = (block as IStrike).strikeShape || StrikeShape.Line;
  function shapeButtonStyle(isSelected: boolean): React.CSSProperties {
    return {
      border: '2px solid',
      borderColor: isSelected ? '#60a5fa' : 'transparent',
      borderRadius: 6,
      padding: 4,
    };
  }

  return (
    <BlockToolbar
      styleProps={{
        cursor: 'move',
        position: 'absolute',
        zIndex: '9999',
      }}
      id={`${block.blockId}-menu`}
      menuText="Strike:"
      blockOptions={props.blockOptions}
    >
      <div className="flex items-center mr-3">
        <span className="mr-2 text-grey-800">Color</span>
        <Button
          data-spec="black-strike-button"
          disabled={strikeColor === StrikeColors.Black}
          onClick={() => handleColorClick(StrikeColors.Black)}
          className="mr-1.5 text-black p-1 min-w-0 rounded-full hover:bg-grey-100"
        >
          {strikeColor === StrikeColors.Black ? <CheckCircleIcon className="bg-white" /> : <LensIcon />}
        </Button>

        <Button
          data-spec="red-strike-button"
          disabled={strikeColor === StrikeColors.Red}
          onClick={() => handleColorClick(StrikeColors.Red)}
          className="mr-1.5 p-1 min-w-0 rounded-full hover:bg-grey-100"
          style={{ color: StrikeColors.Red }}
        >
          {strikeColor === StrikeColors.Red ? <CheckCircleIcon className="bg-white" /> : <LensIcon />}
        </Button>

        <Button
          data-spec="white-strike-button"
          disabled={strikeColor === StrikeColors.White}
          onClick={() => handleColorClick(StrikeColors.White)}
          className="mr-3 text-black p-1 min-w-0 rounded-full hover:bg-grey-100"
        >
          {strikeColor === StrikeColors.White ? <CheckCircleOutlineIcon /> : <LensOutlinedIcon />}
        </Button>

        <span className="mr-2 text-grey-800">Shape</span>
        <Button
          data-spec="line-strike-button"
          disabled={strikeShape === StrikeShape.Line}
          onClick={() => handleShapeClick(StrikeShape.Line)}
          className="mr-1.5 min-w-0 text-black hover:bg-grey-100"
          style={shapeButtonStyle(strikeShape === StrikeShape.Line)}
        >
          <RemoveIcon />
        </Button>
        <Button
          data-spec="rectangle-strike-button"
          disabled={strikeShape === StrikeShape.Rectangle}
          onClick={() => handleShapeClick(StrikeShape.Rectangle)}
          className="min-w-0 text-black hover:bg-grey-100"
          style={shapeButtonStyle(strikeShape === StrikeShape.Rectangle)}
        >
          <StopIcon />
        </Button>
      </div>
    </BlockToolbar>
  );
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default StrikeBlockToolbar;
